"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateTimeFriendly = void 0;
const formatDateTimeFriendly = (date) => {
    // format date to dddd, MMMM D, yyyy without using moment.js
    if (!date)
        return "";
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    // include time
    let hours = d.getHours();
    const minutes = d.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const time = `${hours}:${minutesStr} ${ampm}`;
    return `${time} on ${day} ${monthNames[month]} ${year}`;
};
exports.formatDateTimeFriendly = formatDateTimeFriendly;
